var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1OpacifyingFilterTurnOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 59V13H19v46h-4v4h46v-4h-4zm-34 0V17h13v42H23zm17 0V17h13v42H40zM26 20h7v36h-7V20zm17 0h7v36h-7V20z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Opacifying_filter_turn_off.c3a226eb.svg";
export { SvgC1OpacifyingFilterTurnOff as ReactComponent };